import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { SituacaoContratoEnum } from 'src/app/shared/enums/situacao-contrato.enum';
import { Contrato } from 'src/app/shared/models/contrato.model';
import { StatusLinkPagamentoCelerEnum } from 'src/app/shared/models/pagamento-pix-celer-model';
import DateUtils from 'src/app/shared/utils/date-utils';
import { SituacaoContratoPipe } from '../../situacao-contrato.pipe';

@Component({
  selector: 'app-contrato-table',
  templateUrl: './contrato-table.component.html',
  styleUrls: ['./contrato-table.component.scss']
})
export class ContratoTableComponent implements OnInit {

  @Input()
  contrato: Contrato;

  isMobile: Observable<BreakpointState> = this.breakpointObserver.observe(Breakpoints.Handset);

  constructor(
    private breakpointObserver: BreakpointObserver,
    private currency: CurrencyPipe,
    private situacaoContratoPipe: SituacaoContratoPipe,
  ) { }

  ngOnInit(): void {
  }

  formatarPlanoPorExtenso(contrato: Contrato): string {
    if (contrato && contrato.parcelas && contrato.parcelas.length > 0) {
      return `${contrato.parcelas.length} x ${this.currency.transform(contrato.parcelas[0].valorTotalParcela, 'BRL')}`;
    }
    return '';
  }

  normalizedDate(data: string) {
    if (data) {
      return DateUtils.normalizedDate(data);
    }
  }

  getStatusContrato(contrato: Contrato) {
    if (this.verificarSeParcelaEstaEmProcessamento(contrato)) {
      if (contrato?.linkPagamento?.statusLinkPagamento === StatusLinkPagamentoCelerEnum.PAGO) {
        return 'Em Processamento';
      }

      if (contrato?.linkPagamento?.statusLinkPagamento === StatusLinkPagamentoCelerEnum.AGUARDANDO_PAGAMENTO) {
        return 'Aguardando Pagamento';
      }
    }

    return this.situacaoContratoPipe.transform(contrato?.situacao);
  }

  verificarSeParcelaEstaEmProcessamento(contrato: Contrato): boolean {
    const isAguardandoPagamento = contrato?.situacao === SituacaoContratoEnum.SITUACAO_AGUARDANDO_PAGAMENTO;
    return isAguardandoPagamento && !!contrato?.linkPagamento?.statusLinkPagamento;
  }

}
